module.exports = __webpack_public_path__ + "assets/concierge-care.b2d8c219.png";